var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 58 58"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M37.06 54.622c.275.977 1.292 1.55 2.247 1.209a26.698 26.698 0 10-18.886-.333c.942.376 1.98-.162 2.29-1.128.31-.966-.226-1.993-1.164-2.379a23.024 23.024 0 1116.759.295c-.951.352-1.523 1.36-1.247 2.336z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.164 8.64c-.495-.98-1.694-1.379-2.634-.812a26.697 26.697 0 003.57 47.54c1.014.42 2.14-.155 2.483-1.197.343-1.043-.229-2.157-1.237-2.59a22.724 22.724 0 01-3.019-40.195c.933-.578 1.332-1.766.837-2.746z"
  })));
}
export default SvgProgress2;